import { LAYOUTS, POSITION, } from "@voltmoney/types";
import { BorderRadiusTokens, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, InputTypeToken, SizeTypeTokens, StackAlignContent, StackAlignItems, StackHeight, StackJustifyContent, StackType, StackWidth, TextInputTypeToken, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../routes";
import { ACTION } from "./types";
import { appendCounter, minusCounter, onChangeTab, onLoadMoreData, onSearchLead, onShareLink, onSortLeads, onTrackCustomerJourney, viewDetails, } from "./actions";
import { isMobile, } from "../../configs/utils";
import { LeadsMobEmptyStateStack } from "./indexMobEmptyState";
import { PlatformSideNav } from "../../partnerWeb_Features/sideNavBar/platformSideNav";
import { GoToFaq, GoToHome, GoToPhone, GoToWhatsapp } from "../../partnerWeb_Features/partnerSignUp/actions";
import { onLogoutPress, openMenu } from "../dashboard/actions";
import { platformApi, StoreKey } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
import sharedPropsService from "../../SharedPropsService";
import { TableDataBuilder } from "../dashboard/utils";
import { LeadsMobStack } from "./indexMob";
import { PartnerHeader } from "../dashboard/partnerHeader";
import { debounce } from "lodash";
const _isMobile = isMobile();
export const template = async (firstRenderArray, partnerListData, totalNoOfPages, currentPageNo) => ({
    layout: {
        id: ROUTE.PLATFORM_LEADS,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true,
        },
        widgets: [
            {
                id: 'partnerHeader',
                type: WIDGET.STACK,
                position: POSITION.ABSOLUTE_TOP,
            },
            _isMobile ? {} : { id: 'sideNav', type: WIDGET.STACK, position: POSITION.NAVBAR_LEFT },
            _isMobile ? { id: 'leadsMobRootStack', type: WIDGET.STACK } : { id: 'leadPageRootStack', type: WIDGET.STACK },
        ],
    },
    datastore: {
        ...(await PartnerHeader(ROUTE.PLATFORM_LEADS, true)),
        ...await PlatformSideNav(ROUTE.PLATFORM_LEADS),
        ...await LeadsMobStack(partnerListData),
        leadPageRootStack: {
            width: StackWidth.MATCH_PARENT,
            height: StackHeight.MATCH_PARENT,
            type: StackType.column,
            flex: 1,
            padding: {
                top: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXL,
                left: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXXL,
                right: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXXL,
            },
            widgetItems: firstRenderArray.length > 0
                ? [
                    { id: 'topStack1', type: WIDGET.STACK },
                    { id: 'leadspace0', type: WIDGET.SPACE },
                    { id: 'topStack', type: WIDGET.STACK },
                    { id: 'leadspace1', type: WIDGET.SPACE },
                    { id: 'spaceStack', type: WIDGET.STACK },
                    { id: 'leadTableStack', type: WIDGET.STACK },
                    { id: "pageNumberStack", type: WIDGET.STACK },
                    { id: "leadspace0", type: WIDGET.SPACE },
                ]
                : [
                    { id: 'topStack1', type: WIDGET.STACK },
                    { id: 'leadMobEmptyStateStack', type: WIDGET.STACK }
                ],
        },
        leadTableStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'leadTable', type: WIDGET.TABLE },
            ],
        },
        spaceStack: {
            type: StackType.column,
            hide: true,
            widgetItems: [
                { id: 'leadspace1', type: WIDGET.SPACE },
            ]
        },
        leadTable: {
            numOfCol: partnerListData
                ? partnerListData?.length
                : 0,
            width: StackWidth.MATCH_PARENT,
            height: StackHeight.MATCH_PARENT,
            titleConfig: {
                ...TableDataBuilder(firstRenderArray)
                    .TITLE_CONFIG,
            },
            widgetData: {
                ...TableDataBuilder(firstRenderArray).DATA,
            },
            data: firstRenderArray,
            enablePagination: false,
        },
        ...TableDataBuilder(firstRenderArray).DATA_STORE,
        topStack1: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            justifyContent: StackJustifyContent.spaceBetween,
            widgetItems: [
                { id: 'leadCountStack', type: WIDGET.STACK },
            ],
        },
        leadCountStack: {
            type: StackType.column,
            widgetItems: [
                { id: 'leadCountText', type: WIDGET.TEXT },
                { id: 'leadCountT2', type: WIDGET.TEXT },
            ],
        },
        ...await LeadsMobEmptyStateStack(),
        leadCountT2: {
            label: 'Create & track loan applications in progress',
            fontWeight: '400',
            fontFamily: FontFamilyTokens.Inter,
            color: ColorTokens.Grey_Charcoal,
            lineHeight: 20
        },
        topStackRight1: {
            type: StackType.row,
            widgetItems: [
                {}
            ],
        },
        leadCountText: {
            label: `Leads`,
            fontFamily: FontFamilyTokens.Poppins,
            fontSize: FontSizeTokens.LG,
            fontWeight: '600',
            lineHeight: 26,
        },
        topStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'searchStackLeft', type: WIDGET.STACK },
                { id: 'searchStackRight', type: WIDGET.STACK },
            ],
        },
        searchStackLeft: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            flex: 1,
            widgetItems: [{ id: 'leadSeachInput', type: WIDGET.INPUT }],
        },
        searchStackRight: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            flex: 2,
            widgetItems: [],
        },
        leadSeachInput: {
            title: 'Search Lead',
            value: '',
            width: TextInputTypeToken.CONTENT,
            placeholder: 'Search by name, mobile, partner code',
            type: InputTypeToken.DEFAULT,
            action: {
                type: ACTION.ON_SEARCH_LEADS,
                routeId: ROUTE.PLATFORM_LEADS,
                payload: {
                    value: '',
                    widgetId: 'leadSeachInput',
                },
            },
        },
        leadFilterStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            bgColor: ColorTokens.Grey_Milk,
            borderConfig: {
                borderRadius: BorderRadiusTokens.BR2,
            },
            padding: {
                top: SizeTypeTokens.XL,
                bottom: SizeTypeTokens.XL,
                horizontal: SizeTypeTokens.XL,
            },
            widgetItems: [
                {
                    id: 'applicationStatusFilterInput',
                    type: WIDGET.DROPDOWN_INPUT,
                },
            ],
        },
        pageNumberStack: {
            type: StackType.row,
            justifyContent: StackJustifyContent.spaceBetween,
            width: StackWidth.MATCH_PARENT,
            padding: {
                top: isMobile() ? SizeTypeTokens.XL : SizeTypeTokens.XXXL,
                left: isMobile() ? SizeTypeTokens.XL : SizeTypeTokens.NONE,
                right: isMobile() ? SizeTypeTokens.XL : SizeTypeTokens.NONE,
            },
            widgetItems: [
                {
                    id: "previousPageStack", type: WIDGET.STACK
                },
                {
                    id: "pageNumberMentionStack", type: WIDGET.STACK
                },
                {
                    id: "nextPageStack", type: WIDGET.STACK
                }
            ]
        },
        pageNumberMentionStack: {
            type: StackType.row,
            widgetItems: [
                { id: "currentPageNumber", type: WIDGET.TEXT },
                { id: "pageNumber", type: WIDGET.TEXT },
            ]
        },
        currentPageNumber: {
            label: `Page ${currentPageNo}`,
            fontWeight: '400',
            fontSize: FontSizeTokens.XS,
            lineHeight: 18,
            color: ColorTokens.Grey_Charcoal
        },
        pageNumber: {
            label: ` of ${totalNoOfPages}`,
            fontWeight: '400',
            fontSize: FontSizeTokens.XS,
            lineHeight: 18,
            color: ColorTokens.Grey_Charcoal
        },
        previousPageStack: {
            type: StackType.row,
            alignContent: StackAlignContent.center,
            alignItems: StackAlignItems.center,
            widgetItems: [
                {
                    id: "leftIcon", type: WIDGET.ICON
                },
                {
                    id: "previousText", type: WIDGET.TEXT
                }
            ],
            action: {
                routeId: ROUTE.PLATFORM_LEADS,
                type: ACTION.MINUS_COUNTER
            }
        },
        nextPageStack: {
            type: StackType.row,
            alignContent: StackAlignContent.center,
            alignItems: StackAlignItems.center,
            widgetItems: [
                {
                    id: "nextText", type: WIDGET.TEXT
                },
                {
                    id: "rightIcon", type: WIDGET.ICON
                },
            ],
            action: {
                routeId: ROUTE.PLATFORM_LEADS,
                type: ACTION.APPEND_COUNTER,
                payload: {
                    value: currentPageNo,
                    array: partnerListData,
                    totalNoOfPages: totalNoOfPages
                }
            }
        },
        leftIcon: {
            name: IconTokens.LeftBlackArrowIcon,
            size: IconSizeTokens.XL,
            color: ColorTokens.Grey_Charcoal
        },
        rightIcon: {
            name: IconTokens.RightBlackIcon,
            size: IconSizeTokens.XL,
            color: ColorTokens.Grey_Night
        },
        previousText: {
            label: 'Previous',
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '600',
            fontSize: FontSizeTokens.XS,
            lineHeight: 18,
            color: ColorTokens.Grey_Charcoal
        },
        nextText: {
            label: 'Next',
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '600',
            fontSize: FontSizeTokens.XS,
            lineHeight: 18,
            color: ColorTokens.Grey_Night
        },
        leadDateFilterStack: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            bgColor: ColorTokens.Grey_Milk,
            borderConfig: {
                borderRadius: BorderRadiusTokens.BR2,
            },
            padding: {
                top: SizeTypeTokens.XL,
                bottom: SizeTypeTokens.XL,
                horizontal: SizeTypeTokens.XL,
            },
            widgetItems: [
                { id: 'leadDate1', type: WIDGET.CALENDAR_PICKER },
                { id: 'leadDate2', type: WIDGET.CALENDAR_PICKER },
                { id: 'dateFilterBtn', type: WIDGET.BUTTON },
            ],
        },
        leadspace0: { size: SizeTypeTokens.XXXL },
        leadspace1: { size: SizeTypeTokens.LG },
        leadspace3: { size: SizeTypeTokens.XL },
    }
});
export const platformLeadsMF = {
    onLoad: async ({ asyncStorage, network, navigate, instrumentTrack, ...props }, { setIsUserLoggedIn: boolean, }) => {
        const header = await getAppHeader();
        header['X-AppPlatform'] = await asyncStorage.get(StoreKey.APP_PLATFORM);
        const response = await network.get(`${platformApi.leads}1`, {
            headers: header
        }, async () => {
            return;
        }, {
            isPartnerPlatform: true,
        });
        const totalNoOfPages = response?.data?.totalPages;
        const currentPageNo = response?.data?.currentPageNumber;
        let firstRenderArray = [];
        firstRenderArray = response.data.customerLeadDetails;
        const array = [];
        if (firstRenderArray.length > 0) {
            for (let i = currentPageNo; i <= totalNoOfPages; i++) {
                network.get(`${platformApi.leads}${i}`, {
                    headers: header
                }, async () => {
                    return;
                }, {
                    isPartnerPlatform: true,
                }).then(response => {
                    array.push(...response.data.customerLeadDetails);
                    sharedPropsService.setPlatformLeadsList(array);
                });
            }
        }
        return Promise.resolve(template(firstRenderArray, array, totalNoOfPages, currentPageNo));
    },
    actions: {
        [ACTION.ON_SEARCH_LEADS]: debounce(onSearchLead, 500),
        [ACTION.ON_SORT]: onSortLeads,
        [ACTION.CHANGE_TAB]: onChangeTab,
        [ACTION.ON_LOAD_MORE_DATA]: onLoadMoreData,
        [ACTION.ON_TRACK_CUSTOMER_JOURNEY]: onTrackCustomerJourney,
        [ACTION.GO_TO_HOME]: GoToHome,
        [ACTION.GO_TO_FAQ]: GoToFaq,
        [ACTION.GO_TO_CALL]: GoToPhone,
        [ACTION.GO_TO_WHATSAPP]: GoToWhatsapp,
        [ACTION.LOGOUT]: onLogoutPress,
        [ACTION.OPEN_MENU]: openMenu,
        [ACTION.VIEW_DETAILS]: viewDetails,
        [ACTION.SHARE_LINK]: onShareLink,
        [ACTION.APPEND_COUNTER]: appendCounter,
        [ACTION.MINUS_COUNTER]: minusCounter,
    },
};
